<template>
  <div class="slider" v-if="isActive">
    <div id="demo" class="carousel slide wow fadeInUpBig" data-interval="false">
      <!-- The slideshow -->
      <div class="carousel-inner">
        <div class="carousel-item active">
          <div class="carousel-item-content-flex">
            <h3
              class="sliderfont text-left"
              v-html="$t('exposion_patiens_team')"
            ></h3>
          </div>
        </div>
        <div class="carousel-item">
          <div class="carousel-item-content-flex">
            <div class="carousel-item-content flex-4">
              <h3
                class="sliderfont text-left"
                v-html="$t('composition_surgical_smoke')"
              ></h3>
            </div>
            <div
              class="carousel-item-img-container d-none d-xl-flex flex-2"
              :style="`background-image: url('${zusammensetzungsImageUrl}')`"
            ></div>
          </div>
        </div>

        <div class="carousel-item">
          <div class="carousel-item-content-flex">
            <div class="carousel-item-content flex-4">
              <h3
                class="sliderfont text-left"
                v-html="$t('composition_distribution_particles')"
              ></h3>
              <h3 class="sliderfont text-left">
                {{ $t("percentage_nano_size_particles") }}
              </h3>
            </div>
            <div
              class="carousel-item-img-container d-none d-xl-flex flex-2"
              :style="`background-image: url('${particleImageUrl}')`"
            ></div>
          </div>
        </div>

        <div class="carousel-item">
          <div class="carousel-item-content-flex d-flex">
            <div class="carousel-item-content flex-4">
              <h3
                class="sliderfont text-left"
                v-html="$t('classic_evacuation_ineffective')"
              ></h3>
            </div>
            <div
              class="carousel-item-img-container d-none d-xl-flex flex-2"
              :style="`background-image: url('${lungUrl}')`"
            ></div>
          </div>
        </div>

        <div class="carousel-item">
          <div class="carousel-item-content-flex d-flex">
            <div class="carousel-item-content flex-4">
              <h3 class="sliderfont text-left">
                {{ $t("carbon_nitrogen_oxides_bacteria_viruses") }}
                <span class="d-none d-xs-block">{{
                  $t("large_number_viruses_bacteria_detected")
                }}</span
                ><sup>1</sup>
              </h3>
            </div>
            <div
              class="carousel-item-img-container d-none d-xl-flex flex-1"
              :style="`background-image: url('${co2Url}')`"
            ></div>
          </div>
        </div>

        <div class="carousel-item">
          <div class="carousel-item-content-flex d-flex">
            <div class="carousel-item-content flex-4">
              <h3
                class="sliderfont text-left"
                v-html="
                  $t('chemical_substances_urine_patient_laparascopic_surgery')
                "
              ></h3>
            </div>
            <div class="scrollable d-none d-lg-block flex-2">
              <ul class="slider-list">
                <li
                  v-for="smokeElement in smokeListElements"
                  :key="smokeElement"
                >
                  {{ $t(smokeElement) }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Indicators -->
      <ul class="carousel-indicators">
        <li data-target="#demo" data-slide-to="0" class="active"></li>
        <li data-target="#demo" data-slide-to="1"></li>
        <li data-target="#demo" data-slide-to="2"></li>
        <li data-target="#demo" data-slide-to="3"></li>
        <li data-target="#demo" data-slide-to="4"></li>
        <li data-target="#demo" data-slide-to="5"></li>
      </ul>

      <!-- Left and right controls -->
      <button
        class="carousel-control-prev d-none d-md-block slider-contorl-icon"
        href="#demo"
        data-slide="prev"
      >
        <img src="@/assets/images/arrow_white_prev.png" />
      </button>
      <button
        class="carousel-control-next d-none d-md-block slider-contorl-icon"
        href="#demo"
        data-slide="next"
      >
        <img src="@/assets/images/arrow_white.png" />
      </button>
    </div>
  </div>
</template>

<script>
import { languageAdapter } from "@/services/languageAdapter";
export default {
  name: "SliderIndex",
  data() {
    return {
      smokeListElements: [
        "acetonitrile",
        "acetylene",
        "hydrogen_cyanide",
        "palmitic_acid",
        "acrolein",
        "acrylonitrile",
        "alkylbenzene_sulfonate",
        "benzaldehyde",
        "benzene",
        "nitrobenzene",
        "butadiene",
        "carbon_disulfide",
        "carbon_monoxide",
        "creosote",
        "decen",
        "dihydro_inden",
        "ethane",
        "ethylene",
        "ethylbenzene",
        "formaldehyde",
        "furfural",
        "indole",
        "isobutane",
        "methane",
        "methylbutane",
        "methylfurane",
        "methylphenol",
        "methylpropanol",
        "pak",
        "phenol",
        "polypropylene",
        "pyridine",
        "pyrrole",
        "styrene",
        "toluene",
        "xylene",
        "m_cresols"
      ]
    };
  },
  props: {
    isActive: Boolean
  },
  computed: {
    zusammensetzungsImageUrl() {
      return this.$store.getters.image_zusammensetzung;
    },
    particleImageUrl() {
      return this.$store.getters.image_slider_partikel;
    },
    lungUrl() {
      return this.$store.getters.image_slider_lunge;
    },
    co2Url() {
      return this.$store.getters.image_slider_kohlenmonoxid;
    },
    prevArrow() {
      return this.$store.getters.image_arrow_white_prev;
    },
    nextArrow() {
      return this.$store.getters.image_arrow_white;
    }
  },
  watch: {
    isActive: function() {
      if (this.isActive) {
        setTimeout(() => {
          window.jQuery("#demo").carousel(0);
          const top = window.jQuery("#demo").offset().top - 80;
          window.jQuery("html,body").animate({ scrollTop: top }, 400);
        }, 100);
      }
    }
  }
};
</script>

<style scoped>
.slider {
  background: linear-gradient(
    90deg,
    rgba(241, 255, 67, 0.8) 0%,
    rgba(0, 0, 0, 0.8) 100%
  );
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  color: white;
}
.carousel-inner {
  width: 100vw;
}
.carousel-item div {
  display: flex;
  height: 24rem;
  justify-content: center;
  align-items: center;
}

.carousel-item-content-flex {
  height: auto;
  width: auto;
  max-height: 90%;
  margin: auto;
  width: 75%;
  align-items: center;
  display: flex;
}
.carousel-item-content {
  align-items: stretch !important;
}
.carousel-item-img-container {
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
}
.carousel-item-scrollbar-container {
  width: 100%;
  max-height: 90%;
}
@media (max-width: 767.98px) and (min-width: 576px) {
  .slider,
  .carousel-item div {
    height: 20rem;
  }
  h3 {
    font-size: 1.2rem;
  }
}
@media (max-width: 575.98px) {
  .slider,
  .carousel-item div {
    height: 16rem;
  }
  h3 {
    font-size: 1rem;
  }
}
@media (min-width: 768px) {
  .slider {
    margin-top: -10rem;
  }
}

.carousel-item-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.slider-contorl-icon {
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  display: inline-block;
  margin: auto;
  height: auto;
  max-width: 110px;
  max-height: 110px;
  border: none;
  background-color: transparent;
}

.carousel-indicators {
  margin-bottom: 0;
  height: 100%;
  display: flex;
  align-items: flex-end;
}
.carousel {
  position: static;
}

.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item img {
  width: 90%;
}
.scrollable {
  overflow: scroll;
  position: relative;
  z-index: 100;
  direction: rtl;
}
.slider-list {
  text-align: left;
  list-style: none;
  margin-left: 16px;
  padding-right: 0;
}
.slider-list li {
  font-family: "Netto Light", "Open Sans", sans-serif;
  white-space: nowrap;
  font-size: 1.5rem;
}
</style>
